module.exports = __webpack_public_path__ + "img/ico_plane.e1cc97a0.png";